import { FC } from 'react';

interface Props {
    color?: string;
}

const NotAvailableIcon: FC<Props> = ({ color }) => {
    return (
        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 11.5C8.75 11.5 11 9.25 11 6.5C11 3.75 8.75 1.5 6 1.5C3.25 1.5 1 3.75 1 6.5C1 9.25 3.25 11.5 6 11.5Z"
                fill={color ? color : '#CC1E1C'}
                stroke={color ? color : '#CC1E1C'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.58594 7.91502L7.41594 5.08502"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.41594 7.91502L4.58594 5.08502"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default NotAvailableIcon;
